<div class="card-footer d-flex justify-content-end align-items-center" *ngIf="totalPages > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination mb-0">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <button type="button" class="page-link rounded" (click)="previousPage()" [disabled]="currentPage === 1">
          <span class="page-text">Prev</span>
          <span class="arrow-icon left-arrow"> < </span>
        </button>
      </li>

      <li class="page-item"
          *ngFor="let page of pages"
          [class.active]="page === currentPage"
          [class.disabled]="page === '...'">
        <button type="button" class="page-link rounded"
                (click)="page !== '...' && goToPage(page)"
                [attr.aria-current]="page === currentPage ? 'page' : null"
                [disabled]="page === '...'">
          {{ page }}
        </button>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <button type="button" class="page-link rounded" (click)="nextPage()" [disabled]="currentPage === totalPages">
          <span class="page-text">Next</span>
          <span class="arrow-icon right-arrow"> > </span>
        </button>
      </li>
    </ul>
  </nav>
</div>
